<template>

  <el-dialog :visible.sync="dialogVisible" :show-close="false" custom-class="maxss" width="1410px" top="3vh"
    style="overflow: hidden;" append-to-body>
    <div class="whole" ref="whole">
      <div style="width: 360px;margin-left: 10px; position: fixed;">
        <div class="cloneEvt">
          <span @click="saveEvt" style="cursor: pointer">保存</span>
          <span @click="DelEvt" style="cursor: pointer">删除</span>
        </div>
        <div style="width: 360px;">
          <div class="Completion_status">
            <el-form ref="form" :model="input1" label-width="75px" size="mini">
              <el-form-item label="ID" style="margin-top: 20px; font-size: 12px; padding:0px 10px 0px 10px">
                <el-input v-model="ids" placeholder="请选择" readonly style="width:240px"></el-input>
              </el-form-item>
              <el-form-item label="收入金额" style="margin-top: 20px; font-size: 12px; padding:0px 10px 0px 10px">
                <el-input v-model="amount" placeholder="请填写" style="width:240px"></el-input>
              </el-form-item>
              <el-form-item label="货币单位" style="margin-top: 20px; font-size: 12px; padding:0px 10px 0px 10px">
                <el-select v-model="currency_name_one" filterable placeholder="货币单位" @change="currency_oneChange"
                  clearable>
                  <el-option v-for="(item, index) in currency_one" :key="index" :label="item.name"
                    :value="item.currency_id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收入时间" style="margin-top: 10px; font-size: 12px; padding:0px 10px 0px 10px">
                <el-date-picker v-model="value3" style="width: 240px;margin-left: 6px;" type="date" size="mini"
                  format="yyyy-MM-dd" range-separator="" class="border_box" placeholder="收入时间" end-placeholder=""
                  align="right" value-format="timestamp">
                </el-date-picker>

              </el-form-item>
              <el-form-item label="收入账户" style="font-size: 12px; padding:0px 10px 0px 10px">
                <el-select v-model="bank_name_one" filterable placeholder="收入帐号" @change="bank_oneChange" clearable>
                  <el-option v-for="(value, key) in  bank_one" :key="key" :label="value.name"
                    :value="value.bank_account_id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收入时汇率" style="margin-top: 10px; font-size: 12px; padding:0px 10px 0px 10px"
                class="text_one">
                <el-input v-model="exchange" placeholder="请填写" style="width:240px"></el-input>
              </el-form-item>
              <el-form-item label="收入时折算" style=" font-size: 12px; padding:0px 10px 0px 10px" class="text_one">
                <el-input v-model="converted_amount" placeholder="自动生成" readonly style="width:240px"></el-input>
              </el-form-item>
              <el-form-item label="当时汇率" style=" font-size: 12px; padding:0px 10px 0px 10px" class="text_one">
                <el-input v-model="exchange_rate" placeholder="自动生成" readonly style="width:240px"></el-input>
              </el-form-item>
              <el-form-item label="当前收入折算" style=" font-size: 12px; padding:0px 10px 0px 10px" class="text_one">
                <el-input v-model="converted_now" placeholder="自动生成" readonly style="width:240px"></el-input>
              </el-form-item>
              <el-form-item label="收入类别" style=" margin-top:20px ;font-size: 12px; padding:0px 10px 0px 10px"
                class="text_one">
                <el-select v-model="type_two" filterable placeholder="收入类别" @change="type_twoChange" clearable>
                  <el-option v-for="(item, index) in type_one" :key="index" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="备注" style="margin-top: 20px; font-size: 12px; padding:0px 10px 0px 10px"
                class="text_one">
                <textarea class="text_box_one" style="width:240px;outline: none;height: 290px;margin-left: 5px"
                  v-model="remarks"></textarea>
              </el-form-item>
            </el-form>
          </div>


        </div>
      </div>
      <div class="banner">
        <div style="display: flex;width:100%;justify-content: space-between;padding-top: 4px;">
          <div style="display:flex;">
            <span @click="idsEvt" style="cursor: pointer;" v-if="uniqueNames == '' ? true : false">开始指认</span>
            <span style="width: 255px;margin-left: 10px;;color: #000;text-align: left;">{{ uniqueNames }}</span>
          </div>
          <span
            style="cursor: pointer;width:70px;border-radius: 5px;background-color: #589ff9;color: #Fff;text-align: center"
            @click="shanchu">清空</span>
        </div>
        <div class="content">
          <el-table :data="data_back" style="width: 100%;border-radius: 5px;" max-height="755" class="maxx">
            <el-table-column prop="project_name" label="项目名称" width="300">
            </el-table-column>
            <el-table-column prop="contract_amount" label="合同金额" width="100">
            </el-table-column>
            <el-table-column prop="currency_name" label="货币单位" width="100">
            </el-table-column>
            <el-table-column prop="backed" label="已回金额" width="100">
            </el-table-column>
            <el-table-column prop="unback" label="未回金额" width="100">
            </el-table-column>
            <el-table-column prop="backed_money" label="指向金额" width="100">
            </el-table-column>
            <el-table-column prop="then_exchange" label="当时汇率" width="100">
            </el-table-column>
            <el-table-column prop="then_converted_amount" label="当时指认折算">
            </el-table-column>

          </el-table>
        </div>
      </div>
    </div>


    <el-dialog append-to-body :visible.sync="Identification" :show-close="false" width="60%" top="3vh"
      style="overflow: hidden;" :before-close="clone_oneEvt">
      <div class="fl">
        <el-select v-model="name_e" filterable placeholder="请选择" @change="year_type" class="sel_e">
          <el-option v-for="(item, index) in tableEate" :key="index" :label="item.name" :value="item"> </el-option>
        </el-select>
        <span class="bor_v"><span style="font-size:12px">回款金额:</span> <span style="font-weight: 600;font-size:22px">{{
            back_money || 0 }}</span></span>
        <span class="bor_v">指认合计: <span style="font-weight: 600;font-size:22px">{{ totalMoney || 0 }}</span></span>
        <span class="bor_v">还未指认: <span style="font-weight: 600;font-size:22px">{{ totalMoney || 0 }}</span></span>
        <div>
          <span v-if="yes_one == 1" style="color: rgb(247, 243, 243);background: #61a0e9;" class="Identification"
            @click="submitData"> 确认指认</span>
          <span v-if="yes_one == 2" style="color: rgb(247, 243, 243);background: #aaa9a9;" class="Identification">
            指认中</span>
          <span v-if="yes_one == 3" style="color: rgb(247, 243, 243);background: #aaa9a9;" class="Identification">
            完成指认</span>
        </div>
      </div>
      <el-table class="tabl_e" :data="optionData" @cell-click="optiEvt" :row-class-name="tableRowClassName"
        style="height:740px">
        <el-table-column prop="name" label="项目名称" width="400">
          <template slot="header" slot-scope="scope">
            <div style="display: flex; align-items: center;margin-left: 10px ">
              <span style="flex: 0 0 15%;">项目名称</span>
              <el-switch v-model="radios" style="margin-left: 20px" inactive-text="已回" class="raid"
                active-color="#13ce66" inactive-color="#e5e5e5" @change="radiosEvt"></el-switch>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="contract_amount" label="合同金额" width="100"></el-table-column>
        <el-table-column prop="backed" label="已回金额" width="100"></el-table-column>
        <el-table-column prop="unback" label="未回金额" width="100"></el-table-column>
        <el-table-column prop="curreney_name" label="货币单位" width="100"></el-table-column>
        <el-table-column prop="area" label="指认金额">
          <template slot-scope="scope">
            <el-input :readonly="scope.row.is_self == false" v-model="scope.row.Designated_amount"
              @change="DesignatedEvt(scope.row)" @input="updateTotalAmount(scope.row)"></el-input>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

  </el-dialog>


</template >


<script>
import { ERPIncomeApi, ERPIcmApi, EditApi, IncomeApi, CustomerApi, ProjectApi, IdentifyApi, IdentifydelApi , DelApi } from "@/api/staff/staff.js"

const delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();

export default {
    props: {
    dialogFormVisible: Boolean,
  },
  data() {
    return {
      activeIndex: "7",
      tableData: [],
      tableEate: [],
      optionData: [],
      data_back: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const current = new Date();
              let nowDayOfWeek = current.getDay();
              if (nowDayOfWeek === 0) nowDayOfWeek = 7;
              const dayNum = 1 * 24 * 60 * 60 * 1000;
              const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
              const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "当月",
            onClick(picker) {
              const date = new Date();
              const year = date.getFullYear();
              const month = date.getMonth();
              let thisMonthStartDate = new Date(year, month, 1);
              let thisMonthEndDate = new Date(year, month + 1, 0);
              picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
            },
          },
          {
            text: "当年",
            onClick(picker) {
              var tYear = new Date().getFullYear();
              var startTime = new Date(tYear, 0, 1); //当前年第一天
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, start]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              const current = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
              let nowDayOfWeek = current.getDay();
              let diffToMonday =
                current.getDate() - nowDayOfWeek + (nowDayOfWeek === 0 ? -6 : 1);
              const firstDate = new Date(current.setDate(diffToMonday));
              const lastDate = new Date(current.setDate(diffToMonday + 6));
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              var now = new Date();
              var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
              var ed = new Date(now.getFullYear(), now.getMonth(), 0);
              picker.$emit("pick", [fd, ed]);
            },
          },
          {
            text: "去年",
            onClick(picker) {
              var tYear = new Date().getFullYear() - 1;
              var startTime = new Date(tYear, 0, 1);
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
        ],
      },
      isValue3Empty_1: true,
      isValue3Empty_2: true,
      isValue3Empty_3: true,

      converted_amount: null,
      status: null,
      //排序
      order: null,
      orField: null,

      id: null,
      status_name: null,
      customer_name: null,
      income_time: null,
      currency_name: null,
      type: null,
      bank_name: null,
      remark: null,
      remarks: null,
      sign: null,
      staff: null,

      currency_one: null,
      status_one: null,
      type_one: null,
      bank_one: null,
      sign_one: null,
      staff_one: null,
      project_name: null,

      value0: '',
      value1: '',

      total: null,
      total_one: null,
      paginationInput: 95,
      pagination: null,

      currentPage1: 1,

      currentPage2: 1,
      department_one: null,
      department_two: null,
      settlement_tow: null,
      totalRow: null,

      dialogVisible: false,
      input1: null,
      innerVisible: false,
      activeName: '1',


      amount: null,  //货币金额
      currency_id: null, //货币单位
      bank_account_id: null, //银行账户id
      exchange: null, //收入时汇率
      income_type: null, //收入类别


      currency_name_one: null,
      value3: '',
      bank_name_one: null,
      type_two: null,
      exchange_rate: null,
      converted_now: null,
      ids: null,

      names: null,

      Identification: false,
      radios: 2,
      seek_id: null,
      back_money: null,
      totalMoney: 0,
      inputValues: [],// 定义一个数组来存储输入框的值
      yes_one: 2,
      back_total: null,
      unback_total: null,
      is_success: null,
      backendValue:null,
      name_e: null,
      uniqueNames: null,

    };
  },
  created() {

    ERPIcmApi({}).then((res => {
      this.status_one = res.data.status   //指认情况
      this.type_one = res.data.type   //收入类别
      this.currency_one = res.data.currency   //货币单位
      this.bank_one = res.data.bank      //收入帐号
      this.sign_one = res.data.sign  //签单人
      this.staff_one = res.data.staff   //登记人
    }))


    //弹窗页面搜索
    CustomerApi().then(res => {
      this.tableEate = res.data
    })
  },
  mounted() {
    window.addEventListener("scroll", (e) => this.imgScrollEvt(e), true);

  },
  methods: {
    year_type(selectedValues) {
      this.Identification = true
      this.name_e = selectedValues.name;
      var ids = selectedValues.id;
      let value = this.radios ? 2 : 1; // 判断this.radios值的，将true转换为1，将false转换为2
      ProjectApi({
        income_id: this.selectedId,
        customer_id: ids,
        except: value
      }).then(res => {
        this.optionData = res.data.data
        this.back_money = res.data.back_money_total
        this.uniqueNames = [...new Set(this.optionData.map(res => res.customer_name))];
        this.uniqueNames = this.uniqueNames.join(', ')
      })
    },








    openDialog(resData_one) {
       this.dialogVisible = true;
      if (!resData_one) {
      return;
      }else{
            this.selectedId = resData_one.data.id ;
            this.currency_name_one = resData_one.currency_one;
            this.ids = resData_one.data.id;
            this.amount = resData_one.data.amount;
            this.currency_name_one = resData_one.data.currency_id;
            this.value3 =  Date.parse(resData_one.data.income_time); //
            this.bank_name_one = resData_one.data.bank_account_id;

            this.exchange = resData_one.data.exchange;
            this.converted_amount = resData_one.data.converted_amount;

            this.exchange_rate = resData_one.exchange_rate;
            this.converted_now = resData_one.converted_now;


          this.type_two = resData_one.data.income_type;
            this.remarks = resData_one.data.remark;

            this.data_back = resData_one.data_back;
            this.is_success = resData_one.is_success
            this.unback_total = resData_one.unback_total
            this.back_total = resData_one.back_total
            this.dialogVisible = true
            this.uniqueNames = resData_one.customer_name
      }
    },
    //页面删除
    DelEvt(){
      this.selectedId = this.selectedId
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
         DelApi({
          id: this.selectedId
        }).then(res => {
            if (res.code == 1000) {
                dialogVisible = false
            }else{
              alert(res.msg)
            }
        })
      }).catch(() => {
      });

    },
    //弹窗页面保存
    saveEvt() {
      this.selectedId = this.selectedId
      if (this.selectedId) {
        this.start_time = this.value3 / 1000
        let data = {
          id: this.selectedId,
          amount: this.amount,
          currency_id: this.currency_name_one,  //货币单位
          income_time: this.start_time,  ////收入時間
          bank_account_id: this.bank_name_one, //收入账户
          exchange: this.exchange,  //收入时汇率
          income_type: this.type_two,
          remark: this.remarks,
        };
        EditApi(data).then((res) => {
          if (res.code == 1000) {
            // 保存成功
            this.dialogVisible = false
            // 显示保存成功的提示信息
            this.$message.success('保存成功');
          } else {
            this.dialogVisible = true
            // 保存失败
            this.$message.error('保存失败：' + res.msg);
          }
        });
      } else if (!this.selectedId) {
        this.start_time = this.value3 / 1000
        let data = {
          id: this.selectedId,
          amount: this.amount,
          currency_id: this.currency_name_one,  //货币单位
          income_time: this.start_time,  ////收入時間
          bank_account_id: this.bank_name_one, //收入账户
          exchange: this.exchange,  //收入时汇率
          income_type: this.type_two,
          remark: this.remarks,
        };
        EditApi(data).then((res) => {
          if (res.code == 1000) {
            // 保存成功
            // 显示保存成功的提示信息
            this.$message.success('保存成功');
            this.selectedId = '',
              this.amount = '',
              this.currency_name_one = '',  //货币单位
              this.start_time = '',  ////收入時間
              this.bank_name_one = '', //收入账户
              this.exchange = '',  //收入时汇率
              this.type_two = '',
              this.remarks = '',
              this.value3 = '',
              this.converted_now = '';
            this.converted_amount = '';
            this.exchange_rate = '';
            this.dialogVisible = false
            this.getList()
          } else {
            this.dialogVisible = true
            // 保存失败
            this.$message.error('保存失败：' + res.msg);
          }
        });
      }

    },



    //关闭弹窗前的
    cloneEvt() {
      this.names = '';
      this.tableEate = [];
      this.innerVisible = false
    },
    clone_oneEvt() {
      this.totalMoney = 0;
      this.radios = 2,
        this.totalMoney = 0,
        this.back_money = 0,
        this.uniqueNames = ''
        this.optionData = [],
      this.Identification = false
    },
    //查找后出现的内容
    optionEvt(row, column, cell, event) {
      this.Identification = true
      this.seek_id = row.id
      let value = this.radios ? 2 : 1; // 判断this.radios值的，将true转换为1，将false转换为2
      ProjectApi({
        income_id: this.selectedId,
        customer_id: row.id,
        except: value
      }).then(res => {
        this.optionData = res.data.data
        this.back_money = res.data.back_money_total
      })
    },
    shanchu() {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          IdentifydelApi({
          income_id: this.selectedId
        }).then(res => {
          if (res.code == 1000) {
            this.openChildDialog(2)
            this.$message.success('删除成功');
          }else{
            alert(res.msg)
          }
        })
       }).catch(() => {
      });
    },

    idsEvt() {

      if (this.selectedId) {
        this.innerVisible = true;
        this.Identification = true;
        this.name_e = '';
      }
    },
    //指认金额
    optiEvt(row, column, cell, event) {
      // 处理单元格点击事件
    },
    DesignatedEvt(row) {
      // 在row对象中保存输入的数据
      row.inputData = row.Designated_amount;

      this.inputValues.push(row.Designated_amount);
    },
    updateTotalAmount(row) {
      this.totalMoney = 0
      for (let i = 0; i < this.optionData.length; i++) {
        let row = this.optionData[i];
        if (row.Designated_amount !== 'undefined') {
          let inputValue = parseFloat(row.Designated_amount);
          if (Number.parseFloat(inputValue)) {
            this.totalMoney += inputValue;
          }
        }
      };
      if (this.totalMoney == this.back_money) {
        this.yes_one = 1
      } else {
        this.yes_one = 0
      }
    },
    //点击指认
    submitData() {
      if (this.totalMoney == this.back_money) {
        this.yes_one = 1
        let data = {
          income_id: this.selectedId,
          project: [],
        };
        let whetherSend = false;
        for (let i = 0; i < this.optionData.length; i++) {
          if (this.optionData[i].inputData) {
            whetherSend = true;
            data.project.push({
              project_id: this.optionData[i].id,
              money: this.optionData[i].inputData,
            });
          }
        }
        if (whetherSend) {
          IdentifyApi(data).then((res) => {
            if (res.code == 1000) {
              this.$message('保存成功');
              this.dialogVisible = false;
              this.yes_one = 3;
              this.names = '';

            } else {
              alert(res.msg)
            }
          });
        }
      } else {
        this.yes_one = 2
        alert('未达成回款条件')
      }


    },
    //  点击按钮切换数据
    radiosEvt() {
      let value = this.radios ? 2 : 1;
      if (value == 1) {
        ProjectApi({
          income_id: this.selectedId,
          customer_id: this.seek_id,
          except: value
        }).then(res => {
          this.optionData = res.data.data,
            this.back_money = res.data.back_money_total
        })
      } else if (value == 2) {
        ProjectApi({
          income_id: this.selectedId,
          customer_id: this.seek_id,
          except: value
        }).then(res => {
          this.optionData = res.data.data
          this.back_money = res.data.back_money_total
        })
      }

    },
    tableRowClassName({ row, rowIndex }) {
      if (row.is_self == false) {
        return 'warning-row';
      }
    },
    limitEvt() {
      this.getList();
    },

    showTab(tab) {
      this.activeTab = tab;
    },
    //分页
    handleCurrentChange(res) {
      this.loading = true
      setTimeout(() => {
        this.getList();
        this.loading = false
      }, 100)
    },



    //指认情况
    status_nameChange(key) {
      this.status_name = key;
      this.getList()
    },
    //货币单位
    currencyChange(key) {
      this.currency = key;
      this.getList()
    },


    //收入类别
    typeChange(key) {
      this.type = key;
      this.getList()
    },

    //银行
    bankChange(value) {
      this.bank = value;
      this.getList()
    },
    //签单人
    signChange(value) {
      this.sign = value;
      this.getList()
    },
    //登记人
    staffChange(value) {
      this.staff = value;
      this.getList()
    },

    //弹窗的货币单为
    currency_oneChange(value) {
      this.currency_name_one = value;
    },
    // 收入账户
    bank_oneChange(value) {
      this.bank_name_one = value;
    },
    //收入类别
    type_twoChange(value) {
      this.type_two = value;
    },
    huaguo(row, column, cell, event) {
      this.selectedId = row.id
    },
    idEvt(row, column, cell, event) {
      this.selectedId = row.id
    },
    //点击打开弹窗事件
    openChildDialog(type) {
      if (type == 1) {
        this.selectedId = '',
        this.amount = '',
        this.currency_name_one = '',  //货币单位
        this.start_time = '',  ////收入時間
        this.bank_name_one = '', //收入账户
        this.exchange = '',  //收入时汇率
        this.type_two = '',
        this.remarks = '',
        this.value3 = '',
        this.ids = '';
        this.converted_now = '';
        this.converted_amount = '';
        this.exchange_rate = '';
        this.is_success = '';
        this.unback_total = '';
        this.back_total = '';
        this.dialogVisible = true;
        this.name_e = '';

      } else if (type == 2) {
        //打开收入管理弹窗详情页
        IncomeApi({
          id: this.selectedId
        }).then((res) => {
          if (res.code == 1000) {
            this.currency_name_one = res.data.data.currency_one;
            this.ids = res.data.data.id;
            this.amount = res.data.data.amount;
            this.currency_name_one = res.data.data.currency_id;

            this.value3 = Date.parse(res.data.data.income_time); //
            this.bank_name_one = res.data.data.bank_account_id;

            this.exchange = res.data.data.exchange;
            this.converted_amount = res.data.data.converted_amount;

            this.exchange_rate = res.data.exchange_rate;
            this.converted_now = res.data.converted_now;

            this.type_two = res.data.data.income_type;
            this.remarks = res.data.data.remark;
            this.data_back = res.data.data_back;
            this.is_success = res.data.is_success
            this.unback_total = res.data.unback_total
            this.back_total = res.data.back_total
            this.uniqueNames = res.data.customer_name

            this.dialogVisible = true
          }
        });
      }
    },

    //滑动事件
    imgScrollEvt(e) {
      var e =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        e ||
        document.body.scrollTop;
      //点击分页 滚动条为0
      if (this.pagefenye == true) {
        e.scrollTop = 0;
        this.pagefenye = false
        return
      }
    },
    //列表排序
    sortChangeEvt(row) {
      if (row.order == "ascending") {
        this.order = "asc";
        this.orField = row.prop;
      } else if (row.order == "descending") {
        this.order = "desc";
        this.orField = row.prop;
      } else if (row.order == null) {
        this.order = "";
        this.orField = '';
      }
      this.getList();
    },


    getSummaries(param) {
      const { columns, tableData } = param;
      const sums = [];
      columns.forEach((column, index) => {
        for (let key in this.totalRow) {
          if (column.property == key) {
            sums[index] = this.totalRow[key];
          }
        }
      });
      return sums;
    },





    //获取页面数据
    getList() {
      //入职时间
      let date4 = {
        start: this.value0[0],
        end: this.value0[1],
      };
      //收入时间
      var income_time_start = Math.floor(date4.start / 1000);
      var income_time_end = Math.floor(date4.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate4 = new Date(income_time_end * 1000);
      lastDate4.setHours(23, 59, 59);
      income_time_end = Math.floor(lastDate4.getTime() / 1000);

      //指认日期
      let date3 = {
        start: this.value1[0],
        end: this.value1[1],
      };
      var end_time_start = Math.floor(date3.start / 1000);
      var end_time_end = Math.floor(date3.end / 1000);

      // // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate3 = new Date(end_time_end * 1000);
      lastDate3.setHours(23, 59, 59);
      end_time_end = Math.floor(lastDate3.getTime() / 1000);


      let data = {
        orField: this.orField,
        orWhere: this.order,
        page: this.currentPage1,
        limit: this.paginationInput,


        id: this.id,
        status_name: this.status_name,
        customer_name: this.customer_name,
        income_time: this.income_time,
        currency_name: this.currency_name,
        type: this.type,
        bank_name: this.bank_name,
        remark: this.remark,

        sign: this.sign,
        staff: this.staff,
        project_name: this.project_name,
        //指认日期
        identify_time_start: end_time_start ? end_time_start : '',
        identify_time_end: end_time_end ? end_time_end : '',

        // // //收入时间
        income_time_start: income_time_start ? income_time_start : '',
        income_time_end: income_time_end ? income_time_end : '',
        // //结算时间

      };
      ERPIncomeApi(data).then((res) => {
        this.tableData = res.data;
        this.total = res.total;
        this.totalRow = res.totalRow;
        this.currentPage1 = res.page - 0;

      });

    },
    excelEvt() {
      //入职时间
      let date4 = {
        start: this.value0[0],
        end: this.value0[1],
      };
      //收入时间
      var income_time_start = Math.floor(date4.start / 1000);
      var income_time_end = Math.floor(date4.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate4 = new Date(income_time_end * 1000);
      lastDate4.setHours(23, 59, 59);
      income_time_end = Math.floor(lastDate4.getTime() / 1000);

      //指认日期
      let date3 = {
        start: this.value1[0],
        end: this.value1[1],
      };
      var end_time_start = Math.floor(date3.start / 1000);
      var end_time_end = Math.floor(date3.end / 1000);

      // // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate3 = new Date(end_time_end * 1000);
      lastDate3.setHours(23, 59, 59);
      end_time_end = Math.floor(lastDate3.getTime() / 1000);


      let data = {
        orField: this.orField,
        orWhere: this.order,
        page: this.currentPage1,
        limit: this.paginationInput,


        id: this.id,
        status_name: this.status_name,
        customer_name: this.customer_name,
        income_time: this.income_time,
        currency_name: this.currency_name,
        type: this.type,
        bank_name: this.bank_name,
        remark: this.remark,

        sign: this.sign,
        staff: this.staff,
        project_name: this.project_name,
        //指认日期
        identify_time_start: end_time_start ? end_time_start : '',
        identify_time_end: end_time_end ? end_time_end : '',

        // // //收入时间
        income_time_start: income_time_start ? income_time_start : '',
        income_time_end: income_time_end ? income_time_end : '',
        // //结算时间
        excel: 1,
        activeTab: this.activeName,
      };
      let genExcel = false;
      if (genExcel == false) {
        ERPIncomeApi(data).then((res) => {
          this.loading = false
          // window.location.href = res
          genExcel = true
        });
      } else if (genExcel == true) {
        alert('正在生成数据请勿重复请求')
      }

    },

    //清除数据
    cleanUpEvt() {
      // 清空其他变量和重置表格数据
      this.value0 = '';
      this.value1 = '';
      this.value2 = '';
      this.currentPage1 = 1;
      this.id = '';
      this.status_name = '';
      this.customer_name = '';
      this.income_time = '';
      this.currency_name = '';
      this.type = '';
      this.bank_name = '';
      this.remark = '';

      this.sign = '';
      this.staff = '';
      this.project_name = '';
      this.$refs.sortTable.clearSort();
      ERPIncomeApi({
      }).then((res) => {
        this.tableData = res.data;
        this.currentPage1 = res.page - 0;
        this.total = res.total;
        this.totalRow = res.totalRow;
      });
    },

  },
  watch: {
    'value0': function (newVal, oldVal) {
      this.isValue3Empty_1 = !newVal;
    },
    'value1': function (newVal, oldVal) {
      this.isValue3Empty_2 = !newVal;
    },
    'value2': function (newVal, oldVal) {
      this.isValue3Empty_3 = !newVal;
    },

  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import url("../style/cutomer.less");
@import url("../style/cutomer copy.less");


/* 固定左侧的项目管理列表 */
.el-aside {
  position: fixed;
  top: 50px;
  /* 顶部Header的高度，根据你的实际Header高度调整 */
  left: 0;
  width: 155px;
  height: 100%;
  /* 使其充满整个可视区域的高度 */
  z-index: 99;
  /* 使其在正文内容之上 */
}

.el-main {
  left: 173px;
  /* 与左侧项目管理列表的宽度保持一致 */
  padding: 0px;
  /* 添加一些内边距，使内容不紧贴在边缘 */
  top: 60px;
  position: relative;
}

/deep/.el-submenu__title {
  height: 39px !important;
  line-height: 39px !important;
  list-style: none;
}


.edit {
  // width: 1000px;
  height: 81px;
  display: flex;

  div {
    width: 137px;
    height: 26px;
    cursor: pointer;
  }

  .el-input {
    width: 137px;
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    width: 137px;
    margin-left: 5px;
  }

  span {
    width: 69px;
    height: 26px;
    font-size: 12px;
    border: 1px solid #589ff9;
    line-height: 26px;
    color: #589ff9;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/.el-input__inner {
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    font-size: 12px;
    padding-left: 10px;
  }

  /deep/.el-input--suffix {
    width: 137px !important;
  }

  /deep/.el-input__icon {
    line-height: 0px;
  }
}

.span_box {
  position: absolute;
  left: 1px;
  top: 85px;
  height: 47px;
  width: 80px;
  background: #fff;
  z-index: 120;
  font-size: 14px;
  line-height: 47px;
  text-align: left;
  padding-left: 13px;
}

/deep/.el-table th.el-table__cell {
  background: #dce6ee;
}

.pagination_box {
  min-width: 500px;
  display: flex;
  // align-items: center;
  justify-content: flex-end;
  position: absolute;
  right: 1px;
  z-index: 123;
  cursor: pointer;
}

/deep/.el-tabs--border-card {
  border: none;
}

/deep/.el-tabs--border-card>.el-tabs__content {
  padding: 0 !important;
}

/deep/.el-table__body-wrapper {
  overflow-y: auto;
}

/deep/.el-table__footer-wrapper {
  position: fixed;
  top: 145px;
  z-index: 111;
  height: 49px;
  background-color: #fff;
  width: calc(100% - 178px);
}

.mainx {
  margin-top: 50px;
}

/deep/.el-table th.el-table__cell {
  background: #f5f7fa;
}

/deep/.el-tabs__header {
  width: 100%;
}

/deep/.el-table__footer-wrapper .gutter {
  background: #f5f7fa;
  border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}

.el-menu {
  border: none;
}

/* 添加一个新的类来将总计行移动到最上方 */
.move-top .el-table__summary-cell {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  /* 根据需要调整背景颜色、字体样式等 */
}

/deep/.el-table__fixed-footer-wrapper {
  display: none;
}

/deep/.el-badge__content.is-fixed {
  display: none;
}

/deep/.el-tabs__item {
  border-radius: 3px 3px 0px 0px;
  background: #d9d9d9;
  margin-left: 4px;
  color: #979797;
  font-size: 12px;
}

/deep/.el-tabs__active-bar {
  display: none;
}

/deep/.el-tabs__item {
  padding: 0;
  width: 105px;
  height: 32px;
  line-height: 32px;
}

/deep/.el-tabs__item.is-active {
  background: #fff;
  border: 1px solid #d9d9d9;
  color: #000;
  border-bottom: none;
}

/deep/.el-table__footer-wrapper tbody td.el-table__cell {
  background: #fff;
  border: none;
}

/deep/ .el-table__footer-wrapper .gutter {
  background: #fff !important;
}

//修改tabs的下划线 以及颜色
/deep/.el-tabs__nav-wrap::after {
  height: 0;
  border: 1px solid #d9d9d9;
}

/deep/.el-tabs__nav {
  transform: translateY(1px) !important;
}

/deep/.el-table th.el-table__cell>.cell {
  color: #333333;
  font-size: 12px;
  height: 23px;

}

/deep/.el-table td.el-table__cell div {
  font-size: 12px;
}

/deep/::placeholder {
  color: #59565a;
  /* 这里替换为你想要的颜色值 */
  margin-left: 5px !important;
}



/deep/.el-menu-item:nth-child(1) {
  height: 45px;
  // line-height: 40px;
  color: #292929;
  font-size: 12px;
  padding-left: 20px;
  text-align: center;
}

/deep/.el-menu-item:nth-child(2) {
  height: 44px;
  // line-height: 40px;
  color: #292929;
  font-size: 12px;
  padding-left: 20px;
  text-align: center;
}

/deep/.el-menu-item {
  height: 44px;
  // line-height: 40px;
  color: #292929;
  font-size: 12px;
  padding-left: 20px;
  text-align: center;
}

.maxs {
  background: #f00 !important;
}

/deep/.el-dialog__body {
  padding: 0 !important;
}

/deep/.el-collapse-item {
  width: 490px !important;
}


/deep/.vip .el-input__inner {
  background-color: #bcd9f8d4 !important;
}

//日期选择背景色改变
.your-css-class_box {
  background-color: #bcd9f8d4 !important;
}

//调整下拉选择input
.el-cascader {
  line-height: 25px;
  margin-left: 6px
}

.el-cascader /deep/.el-input__inner {
  height: 27px !important;
  min-width: 137px !important;
}


//溢出隐藏
.white_over {
  white-space: nowrap;
  overflow: hidden;
}



/deep/.el-form-item__label {
  font-size: 12px;
  padding: 0px;
}

/deep/.el-dialog__header {
  background: #D9D9D9;
}

/deep/.el-dialog__body {
  background: #D9D9D9;
}


.whole {
  width: 100%;
  height: 855px;
  display: flex;

  /deep/.el-input {
    width: 240px;
    margin-left: 7px;
  }
}

.banner {
  // width: 76%;
  width: 76%;
  margin-left: 380px;
  height: 835px;
  // overflow: auto;
  padding-right: 7px;
}


.Completion_status {
  height: 755px;
  margin-top: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #fff;
  border-radius: 5px;

  /deep/.el-input__inner {
    display: flex;
    // width: 280px;
    align-items: center;
    border-radius: 5px;
    border: 0.5px solid #D9D9D9;
    height: 30px;
  }

}

/deep/.el-form-item__label {
  padding: 0px;
  font-size: 12px;
  color: #333;
}



// 删除和保存的样式
.cloneEvt {
  display: flex;
  height: 24px;

  span:nth-child(1) {
    display: flex;
    width: 70px;
    padding: 5px 20px;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background: #3383EA;
    font-size: 12px;
    color: #fff;
    margin-right: 10px;
  }

  span:nth-child(2) {
    display: flex;
    width: 70px;
    padding: 5px 20px;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background: #979797;
    font-size: 12px;
    color: #fff;
  }
}

.text_box_one {
  width: 282px;
  height: 150px;
  border-radius: 5px;
  border: 0.5px solid #D9D9D9;
}

.text_one {
  /deep/.el-form-item__content {
    margin-bottom: -10px;
  }
}


.content {
  border: 1px solid #D9D9D9;
  border-radius: 5px;
  height: 801px;

  p:nth-child(1) {
    text-align: right;
    margin-right: 130px;
  }

  p:nth-child(2) {
    text-align: right;
    margin-right: 135px;
  }

  /deep/ .el-table__fixed-body-wrapper {
    overflow: hidden !important;
  }
}



//按钮的颜色点击改变
.raid {
  height: 30px;
  border-radius: 15px;
}

/deep/.el-switch__label.is-active {
  padding: 0px 0px;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
  color: #000;
}

/deep/.el-switch__label {
  padding: 0px 0px;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
  color: #000;
}

/deep/.el-switch__label--left {
  margin-right: 0px;
}


.el-table .warning-row {
  background: #f00;
}

.bor_E {
  height: 30px;
  min-width: 150px;
  line-height: 30px;
}

/deep/.el-table--fit {
  margin-top: 35px !important;
}



.sel_e {
  margin-left: 30px;
}
.bor_v {
  margin-left: 30px;
  width: 140px
}
.Identification {
  color: #fff;
  padding: 5px 20px;
  border-radius: 20px;
  position: absolute;
  right: 10px;
  cursor: pointer;
}
</style>
<style>
/* 日期选择背景色改变 */

.your-css-class_box .el-range-input {
  background-color: #8fc6ff00 !important;
}

/* 日期选择 第四个位置间距拉开 */
.el-picker-panel__sidebar button:nth-child(4) {
  margin-bottom: 30px;
}</style>



// WEBPACK FOOTER //
// src/components/imcole.vue